export default function ArticleImage({ article }) {
  if (!article.image?.src) return null;
  return <figure className="tt-article-image"><img src={article.image.src} alt={article.image.alt || article.title} loading="lazy" />{article.image.caption && <figcaption>{article.image.caption}</figcaption>}</figure>;
}
